import { createAction, props } from "@ngrx/store";
import { PricingInterface } from "src/app/shared/models/location-partners/pricing";
import { CalculatePrice } from "src/app/shared/models/calcul/calculatePrice";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { CreateLPInterface } from "src/app/shared/models/location-partners/createLP";
import { SelectedLps } from "src/app/shared/models/location-partners/selectedLps";
import { GrantPremiumAccess } from "src/app/shared/models/location-partners/GrantPremiumAccess";
import { UpdatePaymentLP } from "src/app/shared/models/update-payment-LP.interface";
import { PricingMethod } from "src/app/shared/enum/pricing-method";
import { AdvertisingCampaignsPaymentLP } from "src/app/shared/models/advertising-campaigns/advertising-campaigns-payment-LP.interface";
import { RemunerationFilterDto } from "src/app/shared/models/franchise/remunerationFilterDto.interface";
import { FranchisesRemunerationWithResultDto } from "src/app/shared/models/franchise/franchisesRemunerationWithResultDto.interface";
import { AssociateLPToFranchiseRequestDto } from "src/app/shared/models/franchise/AssociateLPToFranchiseRequestDto";
import { UpdatePricesDto } from "src/app/shared/models/location-partners/locationPartnersPrices";
import { TotalPriceWithDiscount } from "src/app/shared/models/calcul/totalPrice";

export const invokeCreateLocationPartner = createAction(
  "[Invoke Create LocationPartner] Invoke create LocationPartner",
  props<{ createLocationPartner: CreateLPInterface }>()
);
export const createLocationPartnerSuccess = createAction(
  "[Create Location Partner Success] Create Location Partner success",
  props<{ successMessage: SuccessDto | null }>()
);

export const invokeDeleteLocationPartner = createAction(
  "[Invoke Delete Location Partner] Invoke Delete Location Partner",
  props<{ email: string }>()
);
export const deleteLocationPartnerSuccess = createAction(
  "[Delete LocationPartner Success] Delete LocationPartner Success",
  props<{ successMessage: SuccessDto | null }>()
);

export const invokeCalculateTotalLPCostByCampanyNames = createAction(
  "[ Invoke Calculate Total Location Partners Cost By Campany Names] Invoke Calculate Total Location Partners Cost By Campany Names",
  props<{ calculatePrice: CalculatePrice }>()
);

export const invokeCalculateTotalLPPriceByCampanyNames = createAction(
  "[ Invoke Calculate Total Location Partners Price By Campany Names] Invoke Calculate Total Location Partners Price By Campany Names",
  props<{ calculatePrice: CalculatePrice }>()
);

export const calculateTotalLPCostByCampanyNames = createAction(
  "[ Calculate Total Location Partners Cost By Campany Names ] Calculate total location partners cost by campany names",
  props<{ totalPriceWithDiscount: TotalPriceWithDiscount | null }>()
);

export const calculateTotalLPPriceByCampanyNames = createAction(
  "[ Calculate Total Location Partners Price By Campany Names ] Calculate total location partners price by campany names",
  props<{ totalPriceWithDiscount: TotalPriceWithDiscount | null }>()
);

export const invokePricingByCompanyName = createAction(
  "[ Invoke Location Partner Pricing By CompanyName ] Invoke Location Partner Pricing By CompanyName",
  props<{ companyName: string }>()
);
export const setPricingByCompanyName = createAction(
  "[ set Location Partner Pricing By CompanyName ] set Location Partner Pricing By CompanyName",
  props<{ pricing: PricingInterface | null }>()
);

export const invokeLocationPartnersByRegion = createAction(
  "[ Invoke Location Partners By Region ] Invoke Location Partners by Region",
  props<{ regionNames: string[] }>()
);
export const resultLocationPartnerByRegion = createAction(
  "[ Result Location Partners By Region ] Result lps by Region",
  props<{ lps: string[][] | null }>()
);

export const selectedLPs = createAction(
  "[ Save Selected LPs ] Save selected LPs ",
  props<{ selectedLps: SelectedLps | null }>()
);

export const invokeGrantPremiumAccessForLP = createAction(
  "[ Invoke Grant Premium Access For LP ] Invoke grant premium access for LP",
  props<{ grantPremiumAccess: GrantPremiumAccess }>()
);
export const resultGrantPremiumAccessForLP = createAction(
  "[ Result Grant Premium Access For LP ] Result grant premium access for LP",
  props<{ successMessage: SuccessDto | null }>()
);

export const invokeUpdatePaymentStatusLP = createAction(
  "[ Invoke Update Payment Status LP ] Invoke Payment Status LP",
  props<{ updatePaymentStatusLP: UpdatePaymentLP | null }>()
);
export const resultSuccess = createAction(
  "[ Result Success Message ] Result success message ",
  props<{ successMessage: SuccessDto | null }>()
);

export const invokeAdvertisingCampaignRemunerationForLocationPartner =
  createAction(
    "[ Invoke Location Partner's Advertising Campaigns filter for payment ] Invoke location partner's advertising campaigns filter for payment",
    props<{
      remunerationFilter: RemunerationFilterDto | null;
      refreshCache: boolean;
    }>()
  );
export const resultLocationPartnerAdvertisingCampignFilter = createAction(
  "[ Result Location Partner's advertising Campaigns filter for payment ] Result location partner's advertising campaigns filter for payment",
  props<{
    advertisingCampaignsPaymentLP: AdvertisingCampaignsPaymentLP | null;
  }>()
);

export const saveSelectedLocationsForMap = createAction(
  "[ Save Selected locations for map ] Save selected location for map ",
  props<{ locations: string[] | null }>()
);

export const invokeUpdateApiKey = createAction(
  "[ Invoke Update API Key for location Partner ] Invoke update API Key for location Partner ",
  props<{ apiKey: string; email: string }>()
);

export const resultUpdateApiKey = createAction(
  "[ Result Update API Key for location Partner ] Result update API Key for location Partner ",
  props<{ apiKeySuccess: SuccessDto | null }>()
);

export const invokeRemunerationDetails = createAction(
  "[Invoke remuneration details of advertising campaigns for each franchised of a specific franchise] Invoke remuneration details of advertising campaigns for each franchised of a specific franchise",
  props<{ filter: RemunerationFilterDto; refreshCache: boolean }>()
);

export const resultRemunerationDetails = createAction(
  "[List remuneration details of advertising campaigns for each franchised of a specific franchise] List remuneration details of advertising campaigns for each franchised of a specific franchise",
  props<{ remunerationDetails: FranchisesRemunerationWithResultDto | null }>()
);

export const inovkeAssignLPToFranchise = createAction(
  "[Assign LP to Franchise] assign LP to Franchise",
  props<{ data: AssociateLPToFranchiseRequestDto }>()
);

export const assignLPtoFranchiseSuccess = createAction(
  "[Assign LP to Franchise Success] assign LP to Franchise Success",
  props<{ successMessage: SuccessDto | null }>()
);

export const invokeUpdateLocationPrices = createAction(
  "[Update Location Prices] update location prices",
  props<{ data: UpdatePricesDto }>()
);
